import { useDispatch } from 'react-redux';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppID, SpaceID } from '@playq/octopus-common';

import { kbarToolkit } from '/store';
import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

import { spacesServiceQueryKeys, updateSpaceMutationKey } from '../spacesService';

import { appsQueryTags, IApps, ICurrentApp, updateAppMutationKey } from './constants';

export const useRemoveFavourite = (
  currentApp: ICurrentApp,
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, { app: IApps }>
) => {
  const isSpaceApp = currentApp === ICurrentApp.SPACE;
  const dispatch = useDispatch();

  return useEitherMutation(
    ({ app }) => {
      const isApp = isSpaceApp
        ? services2.spacesService.removeFavourite(app.id as SpaceID)
        : services2.appsService.removeFavourite(app.id as AppID);
      return isApp;
    },
    {
      mutationKey: isSpaceApp ? updateSpaceMutationKey : updateAppMutationKey,
      removeQueriesKeys: isSpaceApp ? spacesServiceQueryKeys : appsQueryTags,
      onSuccess: (_, { app }) => {
        snackbarService.success(`${app.name} has been removed from favorites`);
        dispatch(kbarToolkit.actions.setShouldUpdateApps(true));
      },
      ...options,
    }
  );
};
